<template>
    <svg viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg">        
            <path
                d="M10 16.61l22-2.982V36H10.02L10 16.61zM32 38v20.33l-21.983-3.013L10.016 38H32zm2-24.762L62 9v27H34V13.238zM62 38v24.75l-28-4.1V38h28z"
                
            />        
    </svg>
</template>